import cx from 'classnames'
import { observer } from 'mobx-react-lite'
import { useRef, useState } from 'react'

import { useAppStore } from '@src/app/context'
import Button from '@src/component/ButtonV2'
import Logo from '@src/component/logo/Logo'
import useSize from '@src/lib/hooks/useSize'
import Typography from '@ui/Typography'

import * as styles from './Header.css'

interface HeaderProps {
  className?: string
}

const Header = function ({ className }: HeaderProps) {
  const { service, signOut } = useAppStore()
  const ref = useRef<HTMLDivElement>(null)
  const [isMobile, setIsMobile] = useState(false)

  const isAuthenticated = service.auth.hasSession || service.authV2.isAuthenticated

  useSize({
    ref,
    onResize: ({ width }) => setIsMobile(width <= 520),
  })

  return (
    <div ref={ref} className={cx(styles.root, className)}>
      <Logo className={styles.logo} />
      {isAuthenticated && (
        // eslint-disable-next-line custom-rules/no-deprecated-buttons, @typescript-eslint/no-deprecated -- FIXME: https://linear.app/openphone/issue/UXP-4347/migrate-deprecated-buttons-to-ds-button
        <Button
          variant="text"
          color="textSecondary"
          height={isMobile ? 36 : 32}
          onClick={() => signOut()}
          className={styles.logoutButton}
        >
          {/*
           // @ts-expect-error Provide Typography with a component prop */}
          <Typography variant="caption1" color="textSecondary">
            Log out
          </Typography>
        </Button>
      )}
    </div>
  )
}

export default observer(Header)
